/* eslint-disable react/prop-types */

const InputField = ({ labelText, defaultValue }) => {
  return <label className="w-full">
    <h1>{labelText}</h1>
    <input type="text" defaultValue={defaultValue} className="bg-clouds-100 dark:bg-midnight-700 text-clouds-900 dark:text-midnight-50 flex-1 w-full border border-clouds-950 dark:border-midnight-200 rounded px-2 py-1" />
  </label>
}

export const AdminWork = ({ work, id }) => {
  return <div className="outline outline-clouds-950 dark:outline-midnight-200 rounded-lg p-2 overflow-hidden flex flex-col bg-clouds-200 dark:bg-midnight-800 text-clouds-900 dark:text-midnight-50">
    <h1 className="text-right">{id}</h1>
    <div className="flex flex-col gap-2 justify-center" name={`form-${work.url}`}>
      <InputField labelText="title" defaultValue={work.title} />
      <InputField labelText="type" defaultValue={work.type} />
      <InputField labelText="date" defaultValue={work.date} />
      <InputField labelText="filter" defaultValue={work.filter} />
      <InputField labelText="url" defaultValue={work.url} />
      <label>
        disable &nbsp;<input type="checkbox" defaultChecked={work.disabled} />
      </label>
    </div>
  </div>
}